"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _handlerCreators = _interopRequireDefault(require("./handlerCreators"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getAmexDataManagerConfig = function getAmexDataManagerConfig() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    ddl: {},
    ddlProviderProps: {},
    initialDDL: {},
    reactlyticsProps: {}
  },
      _ref$ddl = _ref.ddl,
      ddl = _ref$ddl === void 0 ? {} : _ref$ddl,
      _ref$ddlProviderProps = _ref.ddlProviderProps,
      ddlProviderProps = _ref$ddlProviderProps === void 0 ? {} : _ref$ddlProviderProps,
      _ref$reactlyticsProps = _ref.reactlyticsProps,
      reactlyticsProps = _ref$reactlyticsProps === void 0 ? {} : _ref$reactlyticsProps,
      _ref$initialDDL = _ref.initialDDL,
      initialDDL = _ref$initialDDL === void 0 ? {} : _ref$initialDDL,
      _ref$extendOnTrackCal = _ref.extendOnTrackCall,
      extendOnTrackCall = _ref$extendOnTrackCal === void 0 ? function () {
    return {};
  } : _ref$extendOnTrackCal;

  var isLocalDevelopment = process.env.NODE_ENV === 'development';

  var onTrackCall = function onTrackCall(_ref2) {
    var context = _ref2.context;
    var event = context.event;
    var timestamp = new Date().toISOString();
    var eventData = extendOnTrackCall(event);
    return {
      name: 'events',
      value: [_objectSpread(_objectSpread(_objectSpread({}, eventData), event), {}, {
        timestamp: timestamp
      })]
    };
  };

  return (0, _deepmerge.default)({
    onTrackCall: onTrackCall,
    ddlProviderProps: {
      enableDiff: true,
      initialDDL: _objectSpread({
        historyLimit: 10,
        history: [],
        ddl: _objectSpread({
          view: isLocalDevelopment ? {
            viewId: 'placeholder',
            location: 'placeholder',
            title: 'placeholder',
            locale: 'zz-ZZ'
          } : {},
          events: [],
          charset: '',
          version: '1.7.0',
          components: {},
          campaigns: {},
          timestamp: new Date().toISOString(),
          device: {},
          user: {}
        }, ddl),
        subscribers: {}
      }, initialDDL)
    },
    reactlyticsProps: {
      handlerCreators: _handlerCreators.default
    }
  }, {
    ddlProviderProps: ddlProviderProps,
    reactlyticsProps: reactlyticsProps
  });
};

var _default = getAmexDataManagerConfig;
exports.default = _default;